import React, { Component } from 'react';
import { Theme } from '@mui/material';
import { Card, CardContent } from '@mui/material';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { createStyles, withStyles } from '@mui/styles';
import { FormType } from '../../constants/constants';
import { resetCancellationRule } from '../../reducers/cancellationRuleSetReducer';
import { RootState } from '../../setup';
import CancellationRuleForm from './cancellationRuleForm';
interface IAddCancellationRuleProps {
    classes: any;
    theme: Theme;
    match: any;
    users: any;
    steps: Array<number>;
    cancellationRuleId?: number;
    cancellationRuleSetVersionId?: number;
    type: FormType;
}

const styles = (theme: Theme) => createStyles({
    root: {
        width: '100%',
        marginTop: '70px',
        display: 'flex'
    },
    cardContent: {
        flex: 1,
        borderTop: '1px #ececec solid',
        borderBottom: 'none',
        marginRight: theme.spacing(5),
        marginLeft: theme.spacing(5)
    }
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    resetCancellationRule: () => dispatch(resetCancellationRule())
});

const mapStoreToProps = (store: RootState, ownProps: IAddCancellationRuleProps) => {
    return {
        cancellationRuleId: ownProps.match.params?.cancellationRuleId ? Number(ownProps.match.params?.cancellationRuleId) : undefined,
        cancellationRuleSetVersionId: ownProps.match.params?.cancellationRuleSetVersionId ? Number(ownProps.match.params?.cancellationRuleSetVersionId) : undefined
    };
};

class AddCancellationRule extends Component<IAddCancellationRuleProps> {
    componentWillUnmount() {
        resetCancellationRule();
    }

    render() {
        const { classes, steps, cancellationRuleId,cancellationRuleSetVersionId, type } = this.props;

        return (
            <Card className={classes.root}>
                <CardContent className={classes.cardContent}>
                    <CancellationRuleForm cancellationRuleId={cancellationRuleId} cancellationRuleSetVersionId={cancellationRuleSetVersionId} steps={steps} type={type} />
                </CardContent>
            </Card>
        );
    }
}

export default withStyles(styles)(connect(mapStoreToProps, mapDispatchToProps)(AddCancellationRule));